import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UserShopcartsState } from './user-shopcarts.state';

export const selectUserShopcartsState = createFeatureSelector<UserShopcartsState>('userShopcarts');

export const getUserCarts = createSelector(
    selectUserShopcartsState,
    (state: UserShopcartsState) => state.carts,
);

export const getPurposeShopcart = createSelector(
    selectUserShopcartsState,
    (state: UserShopcartsState) => state?.carts?.find(
        (shopcart) => shopcart.purpose !== undefined && shopcart.purpose !== null,
    ),
);

export const getUserShopcartProductsToAdd = createSelector(
    selectUserShopcartsState,
    (state: UserShopcartsState) => state.products,
);
